module.exports = __webpack_public_path__ + "img/image02-right-new.bca218ea.jpg";